/**
 * Order JS controller.
 *
 * This class handles the order basket logic.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class Order. This gets mapped with the keyword Order and its
 * docready method is fired automatically on pages where there's a
 * class called 'Order' on the html tag.
 */
class Order {

    /**
     * The class constructor is for binding class properties.
     */
    constructor() {
    }

    /**
     * Cache dom elements for use in the methods
     */
    cache() {

        this.addToBasketButtons         = $( '.js-order' );
        this.productsInBasketIndicators = $( '.js-checkout-link-number' );
        this.orderPopup                 = null;
    }

    /**
     * This handles all event binding of the class.
     */
    events() {

        // Loop through each of the add to basket buttons and bind a click handler to each of them.
        this.addToBasketButtons.each( ( index, button ) => {

            $( button ).on( 'click', () =>  {

                const $button = $( button );
                const product = {
                    id: $button.attr( 'data-id' ),
                    name: $button.attr( 'data-name' )
                };

                this.addToOrderBasket( product, $button );

            });

        });
    }

    /**
     * This fetches the order basket from localStorage and parses it
     * for later use. If there's no orders in the basket, this returns an empty object.
     *
     */
    getOrderBasket() {

        let orderBasket = localStorage.getItem( 'orderBasket' );

        if ( ! Theme.Common.empty( orderBasket ) ) {

            orderBasket = JSON.parse( orderBasket );

        } else {

            orderBasket = {};
        }

        return orderBasket;
    }

    /**
     * This adds a product to the order basket in localStorage. After that
     * it calls the method that updates the basket indicators and also the method
     * that shows the "Product added" popup.
     *
     * @param {object} product The product to be added.
     * @param {object} $button The add to basket -button that was clicked.
     */
    addToOrderBasket( product, $button ) {

        const orderBasket = this.getOrderBasket();

        if ( orderBasket.hasOwnProperty( product.id ) ) {
            orderBasket[ product.id ].count++;
        } else {
            orderBasket[ product.id ] = { name: product.name, count: 1 };
        }

        localStorage.setItem( 'orderBasket', JSON.stringify( orderBasket ) );

        this.updateBasketIndicators();
        this.showBasketPopup( $button );
    }

    /**
     * This updates the indicator number and the screen reader equivalent by
     * fetching the basket data and adding together the amounts of each product.
     *
     */
    updateBasketIndicators() {

        const orderBasket = this.getOrderBasket();
        let amount        = 0;

        _.forEach( orderBasket, ( property ) => {
            amount += property.count;
        });

        this.productsInBasketIndicators.text( amount );
    }

    /**
     * This shows the popup associated with each product when the product is
     * added to the order basket.
     *
     * @param {object} $button The add to basket -button that was clicked.
     */
    showBasketPopup( $button ) {

        const $originalPopup = $button.next( '.product__actions__added-to-basket' );
        this.originalPopup   = $originalPopup;

        $originalPopup.remove();
        $button.after( this.originalPopup );

        const $newPopup = $button.next( '.product__actions__added-to-basket' );
        $newPopup.addClass( 'js-active' );
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
        this.updateBasketIndicators();
    }
}

// Export the class reference.
module.exports = Order;



// WEBPACK FOOTER //
// ./assets/scripts/order.js